export function getGtmConfig() {
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID || null;

  return {
    gtmEnabled: Boolean(gtmId),
    gtmId,
  };
}
